import app, {DEVICE_TYPE_DESKTOP} from 'app-instance'
import contentBlocker from 'content-blocker';

class MenuManager {

    constructor() {
        this.menuCollection = {};

        this.stack = [];

        this.defaultMenuConfig = {
            isBlocking: true,
            isEnabled: true
        };

        app.addListener('device-type-changed', (oldDeviceType, newDeviceType) => {
            if (oldDeviceType === DEVICE_TYPE_DESKTOP || newDeviceType === DEVICE_TYPE_DESKTOP) {
                this.switchBetweenDeviceType();
            }
        })
    }

    init(id, menuConfig) {
        if (menuConfig.default === undefined) {
            menuConfig.default = {};
        }
        menuConfig.default.id = id;
        this.menuCollection[id] = menuConfig;
    }

    open(id) {
        let config = this.getMenuConfig(id);
        if (config && config.isEnabled) {
            this.openMenu(config);
        }
    }

    isOpened(id) {
        return this.stack.some((openedMenu) => openedMenu.id === id);
    }

    openMenu(config) {
        let {isBlocking, level} = config;
        while (this.stack.length > 0) {
            let prevMenu = this.stack[this.stack.length - 1];
            if (prevMenu.level >= level) {
                this.stack.pop();
                prevMenu.close();
            } else {
                break;
            }
        }

        if (isBlocking) {
            if (!contentBlocker.isBlocked('menu')) {
                contentBlocker.block('menu');
            }
        }

        this.stack.push(config);
        config.open();
    }

    close(id) {
        while (this.stack.length > 0) {
            let prevMenu = this.stack.pop();
            prevMenu.close();
            if (prevMenu.id === id) {
                break;
            }
        }

        //there is no top level menu still in stack
        if (this.stack.length === 0) {
            contentBlocker.unblock('menu');
        }
    }

    getMenuConfig(name) {
        if (!(name in this.menuCollection)) {
            return null;
        }

        let menuConfig = this.menuCollection[name];
        let deviceConfig;
        if (app.isDesktop) {
            deviceConfig = menuConfig['desktop'];
        } else {
            deviceConfig = menuConfig['mobile'];
        }

        return {...this.defaultMenuConfig, ...menuConfig['default'], ...deviceConfig};
    }

    switchBetweenDeviceType() {
        while (this.stack.length > 0) {
            let prevMenu = this.stack.pop();
            prevMenu.close();
        }
        contentBlocker.unblock('menu');
    }
}

let instance = new MenuManager();

export default instance;



// WEBPACK FOOTER //
// ./app/general/js/menu-manager.js